var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "root" },
    [
      _setup.loadState === "loading"
        ? _c(_setup.LoadingSpinner, {
            attrs: { size: "medium", variant: "inline" },
          })
        : _setup.loadState === "error"
        ? _c("p", { staticClass: "load-error", attrs: { role: "alert" } }, [
            _vm._v(
              " " +
                _vm._s(_setup.t("contestEntryForm.step3.contestLoadError")) +
                " "
            ),
          ])
        : _setup.contest
        ? _c(
            "div",
            { staticClass: "contents" },
            [
              _c("section", { staticClass: "panel" }, [
                _c("img", {
                  staticClass: "complete-icon",
                  attrs: {
                    src: require("@/assets/img/contest-entry-complete-check.svg"),
                    alt: "",
                    width: "80",
                    height: "80",
                  },
                }),
                _c("h1", { staticClass: "title" }, [
                  _vm._v(_vm._s(_setup.t("contestEntryForm.completed.title"))),
                ]),
                _c(
                  "div",
                  { staticClass: "message" },
                  [
                    _c(
                      "i18n",
                      {
                        attrs: {
                          path: "contestEntryForm.completed.lead",
                          tag: "p",
                        },
                      },
                      [
                        _c(
                          "strong",
                          {
                            staticClass: "contest-name",
                            attrs: { place: "contestName" },
                          },
                          [_vm._v(_vm._s(_setup.contest.contest))]
                        ),
                      ]
                    ),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _setup.t("contestEntryForm.completed.changeNotice")
                        )
                      ),
                    ]),
                    _c("p", [
                      _vm._v(
                        _vm._s(
                          _setup.t("contestEntryForm.completed.manageNotice")
                        )
                      ),
                    ]),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "actions" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "action-button action-button-primary",
                        attrs: { to: { name: "entries" } },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _setup.t("contestEntryForm.completed.history")
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _c(
                      "router-link",
                      {
                        staticClass: "action-button action-button-secondary",
                        attrs: { to: { name: "home" } },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _setup.t("contestEntryForm.completed.home")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
              _c(_setup.ContestEntryFormContestAside, {
                attrs: { contest: _setup.contest },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }